<template>
  <div class="page page__catalog-main">
    <div class="category-grid">
      <div class="category-grid__item-wrapper category-koltsa">
        <router-link :to="{ name: 'catalog', params: { category: 'kolca' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Кольца</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/1.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-sergi">
        <router-link :to="{ name: 'catalog', params: { category: 'sergi' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Серьги</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/2.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-tsepochki">
        <router-link :to="{ name: 'catalog', params: { category: 'cepi' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Цепи</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/5.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-podveski-kulony">
        <router-link :to="{ name: 'catalog', params: { category: 'kulon' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Кулон</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/4.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-braslety">
        <router-link :to="{ name: 'catalog', params: { category: 'braslety' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Браслеты</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/braslety.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-kole">
        <router-link :to="{ name: 'catalog', params: { category: 'kole' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Колье</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/kole.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-pirsingi">
        <router-link :to="{ name: 'catalog', params: { category: 'pirsing' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Пирсинг</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/12.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-broshi">
        <router-link :to="{ name: 'catalog', params: { category: 'brosi' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Броши</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/broshi.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-zaponki">
        <router-link :to="{ name: 'catalog', params: { category: 'zaponki' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Запонки</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/zaponki.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-zakolki">
        <router-link :to="{ name: 'catalog', params: { category: 'zazimy-dlya-galstuka' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Зажимы для галстука</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/13.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-chasy">
        <router-link :to="{ name: 'catalog', params: { category: 'casy' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Часы</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/casy.png"
            alt=""
          />
        </router-link>
      </div>
      <!-- <div class="category-grid__item-wrapper category-placeholder">
        <router-link :to="{ name: 'catalog', params: { category: 'bulavki' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Булавки</div>
          </div>
          <img
            class="item-image"
            src="https://zu.ru/local/templates/zu/images/catalog-main/items/placeholder.png"
            alt=""
          />
        </router-link>
      </div> -->
      <div class="category-grid__item-wrapper category-yuvelirnye-suveniry">
        <router-link :to="{ name: 'catalog', params: { category: 'yuvelirnye-suveniry' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Сувениры</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/yuvelirnye-suveniry.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-komplekty">
        <router-link :to="{ name: 'catalog', params: { category: 'komplekty' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Комплекты</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/komplekty.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-sarmy">
        <router-link :to="{ name: 'catalog', params: { category: 'sarmy' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Шармы</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/sarmy.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-zakolki">
        <router-link :to="{ name: 'catalog', params: { category: 'zakolki' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Заколки</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/zakolki.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-tiary">
        <router-link :to="{ name: 'catalog', params: { category: 'tiary' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Тиары</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/tiary.png"
            alt=""
          />
        </router-link>
      </div>
      <div class="category-grid__item-wrapper category-sotuary">
        <router-link :to="{ name: 'catalog', params: { category: 'sotuary' } }" class="category-grid__item">
          <div class="info">
            <div class="title">Сотуары</div>
          </div>
          <img
            class="item-image"
            src="/assets/images/sotuary.png"
            alt=""
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
/* Start:/local/templates/zu/css/catalog-main.css?160812691512353*/
.page__catalog-main {
  padding-bottom: 70px;
  position: relative;
}
.page__catalog-main .thanq__wrapper {
  color: #000000;
  font-size: 20px;
  padding: 35px 0 15px;
}
.page__catalog-main .thanq__wrapper, .page__catalog-main .thanq__wrapper .thanq__title {
  font-weight: 300;
  line-height: 30px;
}
.page__catalog-main .thanq__wrapper .thanq__title {
  font-size: 24px;
}
.page__catalog-main a {
  text-decoration: none;
  color: #4695cc;
}
.page__catalog-main .category-grid {
  padding: 0 10px;
  margin: 10px auto 0;
  width: 100%;
  max-width: 1300px;
  font-size: 0;
}
.page__catalog-main .category-grid .category-grid__item-wrapper {
  display: inline-block;
  vertical-align: top;
  *vertical-align: auto;
  *zoom: 1;
  *display: inline;
  padding: 0 10px;
  margin: 0 0 20px;
  width: 25%;
}
.page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(1), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(2), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(3), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(4), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(5) {
  height: 400px;
}
.page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(1), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(2), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(5) {
  width: 50%;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-koltsa .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/1.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-koltsa .category-grid__item .item-image {
  right: 40px;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-sergi .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/2.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-braslety .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/3.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-braslety .category-grid__item .item-image {
  top: 60px;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-podveski-kulony .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/4.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-podveski-kulony .category-grid__item .item-image {
  bottom: auto;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-tsepochki .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/5.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-tsepochki .category-grid__item .item-image {
  min-height: 100%;
  min-width: 100%;
  left: 0;
  right: auto;
  max-width: none;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-kole .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/6.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-kole .category-grid__item .item-image {
  bottom: auto;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-kulony .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/7.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-zaponki .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/8.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-zaponki .category-grid__item .item-image {
  top: auto;
  bottom: 10px;
  height: 70%;
  right: 10px;
  
}

.page__catalog-main .category-grid .category-grid__item-wrapper.category-komplekty .category-grid__item .item-image {
    top: -42px;
    height: 54%;
    right: 10px;
  
}

.page__catalog-main .category-grid .category-grid__item-wrapper.category-yuvelirnye-suveniry .category-grid__item .item-image {
  top: 67px;
  height: 76%;
  right: 0;
  opacity: 1;
  
}


.page__catalog-main .category-grid .category-grid__item-wrapper.category-krestiki .category-grid__item {
  background-image: url("https://zu.ru/local/templates/zu/css/../images/catalog-main/bg/9.png");
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-krestiki .category-grid__item .item-image {
  height: 100%;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-chasy .category-grid__item {
  background: #faf6fa;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-chasy .category-grid__item .item-image {
  top: auto;
  right: 15px;
  @media all and (max-width: 768px) {
    height: 100%;
    max-height: 100%;
    right: 0;
  }
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-pirsingi .category-grid__item {
  background: #fbf9fa;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-pirsingi .category-grid__item .item-image {
  right: 15px;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-pusety .category-grid__item {
  background: #fbfdfd;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-pusety .category-grid__item .item-image {
  right: -5px;
  height: 100%;
  max-height: 100%;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-placeholder .category-grid__item {
  background: #fafafa;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-placeholder .category-grid__item .item-image {
  right: 15px;
  opacity: 0.1;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-zakolki .category-grid__item {
  background: #f4f9fa;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-zakolki .category-grid__item .info .title:after {
  max-width: 70px;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-zakolki .category-grid__item .item-image {
  right: 2px;
  bottom: 0;
  top: auto;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-broshi .category-grid__item {
  background: #f1f3f3;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-broshi .category-grid__item .item-image {
  right: 20px;
  height: 80%;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-ikonki .category-grid__item {
  background: #faf9eb;
}
.page__catalog-main .category-grid .category-grid__item-wrapper.category-ikonki .category-grid__item .item-image {
  right: 10px;
  top: 0;
  bottom: auto;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item {
  display: block;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 200px;
  border: 0;
  background-size: cover;
  background-position: center center;
  position: relative;
  padding: 39px 50px;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item:before {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #ff8c3f;
  opacity: 0;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item:hover:before {
  opacity: 0.7;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item:hover .info .title, .page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item:hover .info .price {
  border-color: #ffffff;
  color: #ffffff;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item:hover .info .title:after, .page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item:hover .info .price:after {
  background: #FFFFFF;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .info {
  position: relative;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .info .title {
  font-weight: 300;
  font-size: 24px;
  line-height: 44px;
  color: #000000;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  display: inline-block;
  vertical-align: middle;
  *vertical-align: auto;
  *zoom: 1;
  *display: inline;
  z-index: 1;
  position: relative;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .info .title:after {
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  background: #ff8c3f;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .info .price {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  margin: 18px 0 0;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .item-image {
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
}

@media screen and (max-width: 1279px) {
  .page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item {
    padding: 20px 25px;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .item-image {
    max-height: 70%;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(5) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(9) .category-grid__item .item-image {
    max-height: 100%;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(9) .category-grid__item .item-image {
    right: -30px;
  }
}
@media screen and (max-width: 1023px) {
  .page__catalog-main .category-grid {
    padding: 0 15px;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper {
    padding: 0 5px;
    margin-bottom: 10px;
    width: 50%;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(1), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(2), .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(5) {
    width: 100%;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .item-image {
    max-height: 100%;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(1) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(2) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(7) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(9) .category-grid__item .item-image {
    right: 30px;
  }
}
@media screen and (max-width: 767px) {
  .page__catalog-main .category-grid .category-grid__item-wrapper .category-grid__item .item-image {
    max-height: 70%;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(1) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(2) .category-grid__item .item-image {
    right: 0px;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(4) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(6) .category-grid__item .item-image {
    right: -20px;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(7) .category-grid__item .item-image {
    right: -30px;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(9) .category-grid__item .item-image {
    right: -50px;
  }
  .page__catalog-main .thanq__wrapper {
    font-size: 14px;
    padding: 0;
  }
  .page__catalog-main .thanq__wrapper, .page__catalog-main .thanq__wrapper .thanq__title {
    line-height: 24px;
  }
  .page__catalog-main .thanq__wrapper .thanq__title {
    font-size: 18px;
  }
}
@media screen and (max-width: 479px) {
  .page__catalog-main .category-grid .category-grid__item-wrapper {
    width: 100% !important;
    height: 250px !important;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(4) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(7) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(9) .category-grid__item .item-image {
    right: 0;
  }
  .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(1) .category-grid__item .item-image, .page__catalog-main .category-grid .category-grid__item-wrapper:nth-child(2) .category-grid__item .item-image {
    top: auto;
    max-height: 60%;
  }
}

/* End */
/* /local/templates/zu/css/catalog-main.css?160812691512353 */

</style>